import { isNilOrEmpty, isNotNilOrEmpty } from '@pcty/utils';
export var getFloat = function (value) {
    if (typeof value === 'number') {
        return value;
    }
    var isNegative = value.length > 0 && value[0] === '-';
    var regex = /[0-9..]/g;
    var match = value.match(regex);
    var array = isNotNilOrEmpty(value) && match ? match.join('').split('.') : [];
    var output = '';
    if (array.length > 1) {
        output = array[0] + '.' + array.slice(1, array.length).join('');
    }
    else {
        output = array.join('');
    }
    if (isNegative) {
        output = '-' + output;
    }
    return parseFloat(output);
};
export var compareMax = function (value, max) {
    if (isNilOrEmpty(max)) {
        return value;
    }
    if (value > getFloat(max)) {
        return max;
    }
    return value;
};
export var compareMin = function (value, min) {
    if (isNilOrEmpty(min)) {
        return value;
    }
    if (value < getFloat(min)) {
        return min;
    }
    return value;
};
export var processValue = function (value, min, max) {
    if (isNilOrEmpty(value) || (isNotNilOrEmpty(value) && value.toString().search(/\d/g) < 0))
        return 0;
    value = getFloat(value);
    if (max)
        return compareMax(value, max);
    if (min)
        return compareMin(value, min);
    return value;
};
// if min undefined, allow infinite decrement
export var shouldDecrementBeEnabled = function (disabled, formDisabled, value, min) {
    if (disabled || formDisabled)
        return false;
    if (min === undefined)
        return true;
    var numValue = Number(value);
    return numValue > min;
};
// if max undefined, allow infinite increment
export var shouldIncrementBeEnabled = function (disabled, formDisabled, value, max) {
    if (disabled || formDisabled)
        return false;
    if (max === undefined)
        return true;
    var numValue = Number(value);
    return numValue < max;
};
